module.exports = __webpack_public_path__ + "static/media/article3.665e0a9e.jpeg";